<template>
  <div class="page_wrapper">
    <carousel-section />
    <news-section :pieces-news="latestNews" />
    <jobs-section />
    <links-section />
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import CarouselSection from '~components/pages/home/Carousel'
import NewsSection from '~components/pages/home/News'
import JobsSection from '~components/pages/home/Jobs'
import LinksSection from '~components/pages/home/PromotionLinks'
import '~style/pages/home.scss'
export default {
  name: 'Home',
  routerName: 'Home',
  components: {
    CarouselSection,
    NewsSection,
    JobsSection,
    LinksSection
  },
  data: function () {
    return {
      latestNews: [{
        id: 1,
        title: '【職涯工作坊】12/8(六)、12/15(六)做自己人生的規劃師 職涯藍圖設計工作坊',
        type: 1,
        start_time: 1554851313
      }, {
        id: 2,
        title: '【職涯工作坊】12/8(六)、12/15(六)做自己人生的規劃師 職涯藍圖設計工作坊',
        type: 2,
        start_time: 1554851313
      }, {
        id: 3,
        title: '【職涯工作坊】12/8(六)、12/15(六)做自己人生的規劃師 職涯藍圖設計工作坊',
        type: 3,
        start_time: 1554851313
      }, {
        id: 4,
        title: '【職涯工作坊】12/8(六)、12/15(六)做自己人生的規劃師 職涯藍圖設計工作坊s',
        type: 4,
        start_time: 1554851313
      }]
    }
  },
  created () {
    // this.getUniqueVisitorCount()
  },
  mounted () {
    window.$(window).on('scroll', function () {
      if (window.$(window).scrollTop() > 50) {
        window.$('.site_header').addClass('original')
      } else {
        window.$('.site_header').removeClass('original')
      }
    })

    // mobile menu modal
    const modalWindow = document.getElementById('mobile-menu-modal')

    window.$('.mobile_menu_btn').on('click', function () {
      modalWindow.classList.add('active')
    })

    window.$('.js-mobile-header-close').on('click', function () {
      modalWindow.classList.remove('active')
    })
  }
  // methods: {
  //     ...mapActions('layouts', [
  //     'getUniqueVisitorCount'
  // ])
  // }
}
</script>
